import { inject, Service } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { Store } from '@ngrx/store';

import {
  AppState,
  setSidebarVisibility,
  toggleSidebarVisibility,
  updateUserData,
} from '@store';
import { UserBeanService } from './user-bean.service';

@Service()
export class UIService {
  userBeanService = inject(UserBeanService);
  store: Store<AppState> = inject(Store<AppState>);
  isSidebarVisible = toSignal(
    this.store.select((state) => state.sidebar.isVisible),
    { initialValue: true }
  );

  toggleSidebar = async (isVisible?: boolean) => {
    if (isVisible === undefined) {
      const prevValue = this.isSidebarVisible();

      await this.userBeanService.setSidebarVisibility(!prevValue);
      this.store.dispatch(toggleSidebarVisibility());
      this.store.dispatch(
        updateUserData({ payload: { preferences: { sidebar: !prevValue } } })
      );
    } else {
      await this.userBeanService.setSidebarVisibility(isVisible);
      this.store.dispatch(setSidebarVisibility({ payload: isVisible }));
      this.store.dispatch(
        updateUserData({ payload: { preferences: { sidebar: isVisible } } })
      );
    }
  };
}
